import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Resources from 'components_new/pages/Resources'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Resources />}
        path={'/resources/folders/:id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Resources />}
        path={'/resources'}
      />
      <Route path={'/resources/*'}>
        <Redirect to="/resources" />
      </Route>
    </Switch>
  )
}

export default Routes
